<template>
  <div></div>
</template>
<script>
/* eslint-disable */
import {
  QFetchHouse,
  QFetchFaviroteList,
  QFetchFavirote
} from '@/services/q_house'
import { Sniff } from '@/utils/q_sniff'
import { loginQ } from '@/utils/q_userinfo'
import { getStorge, saveStorge, format, formatText, localKeys, getFromForLog, throttle, RouterHelper, openScheme } from '@/utils/q_business'
import sendLog from '@/utils/q_log'
import { getLinks } from '@/utils/linkUtil'
import qunarRedirect from '@/utils/qunarRedirect'
const ONE_DAY = 1000 * 60 * 60 * 24 // 一天的时间戳
export default {
  mixins: [qunarRedirect],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      fromDate: '',
      toDate: ''
    }
  },
  watch: {
    payLoad(newVal) {
      // eslint-disable-next-line
      if (newVal && newVal.type === 'openHouseInfo') {
        const logParam = {
          actPos: `${this.compIndex}_${newVal.houseIndex}_1`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_houseCard`
        }
        sendLog(logParam)
        this.showHouseInfo(newVal.data)
      } else if (newVal && newVal.type === 'favoriteHouse') {
        loginQ().then(() => {
          const logParam = {
            actPos: `${this.compIndex}_${newVal.data.houseIndex}_0`,
            actPage: `cms_${this.$root.promotionId}`,
            actText: `cms_${this.$root.promotionId}_favoriteBtn`
          }
          sendLog(logParam)
          this.doFavorite(newVal.data)
        }).catch((err) => { console.log(err) })
      }
    }
  },
  mounted() {
      const startTime = this.compProps.fromDate
      const endTime = this.compProps.toDate
      if (startTime && endTime) {
        this.fromDate = format('yyyy-MM-dd', new Date(startTime))
        this.toDate = format('yyyy-MM-dd', new Date(endTime))
      } else {
        let date = new Date()
        this.fromDate = format('yyyy-MM-dd', date)
        this.toDate = format(
          'yyyy-MM-dd',
          new Date(+date.getTime() + ONE_DAY)
        )
      }
  },
  methods: {
    /**
     * 跳转房屋详情
     * @param {Number} unitId 房屋id
     */
    showHouseInfo(unitId) {
      const PAGE_DETAIL = 'detail'
      const fromForLog = getFromForLog()
      const houseID = unitId
      let params = {
        fromForLog,
        houseID,
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      // const url = RouterHelper(PAGE_DETAIL, params)
      // const _openScheme = throttle(this.openScheme, 800)
      // _openScheme(url)
      const links = getLinks('detail', {
        houseId: params.houseID,
        checkInDate: params.fromDate,
        checkOutDate: params.toDate,
        channelId: fromForLog
      })
      this.redirectTo({
        mpLink: links.mpUrl,
        appLink:
          `react/open?hybridId=tj_order_qtaro_rn&pageName=DetailPageTaro&initProps=${encodeURIComponent(
            JSON.stringify({
              param: {
                houseId: params.houseID,
                checkInDate: params.fromDate,
                checkOutDate: params.toDate,
                channelId: fromForLog,
              },
            }),
          )}` || links.qAPPUrl,
        activeLink: links.webUrl
      })
    },
    /**
     * 收藏
     * @param {Object} house 房屋
     */
    async doFavorite(house) {
      const res = await QFetchFavirote(house, this.fromDate, this.toDate)
      const collectMap = getStorge(localKeys.HOUSE_COLLECTION) || {}
      const houseID = house.id
      if (res.ret) {
        if (house.isLike) {
          collectMap && collectMap[houseID] && delete collectMap[houseID]
          saveStorge(localKeys.HOUSE_COLLECTION, collectMap)
        } else {
          collectMap[houseID] = true
          saveStorge(localKeys.HOUSE_COLLECTION, collectMap)
        }
        this.$emit('finish', {
          type: 'favirote',
          data: { id: house.id, isLike: !house.isLike }
        })
      }
    },
    // openScheme(url) {
    //   if (Sniff.qunar) {
    //     const hysdk = window.hysdk
    //     hysdk && hysdk.openWebView({ url, type: 'navibar-none' })
    //     return
    //   }
    //   if (Sniff.miniprogram) {
    //     openScheme(url)
    //     return
    //   }
    //   const scheme = Sniff.ios ? 'qunariphone' : 'qunaraphone'
    //   const schemeUrl = `${scheme}://hy?url=${encodeURIComponent( url )}&type=navibar-none`
    //   window.location.href = schemeUrl
    //   window.setTimeout(() => { window.location.href = url }, 500)
    // }
  }
}
</script>
